// import CryptoJS from "./crypto-js.min.js"
// import md5 from "./md5.min.js"
// import store from "../store/index"
// import api from "@/api/lxc/index.js" 

//获取用户信息
// const getUser = ()=>{
    // return 1
    // new Promise((resolve,reject)=>{
    //     getUserInfo().then((res)=>{
    //         console.log(res)
    //         resolve(res)
    //     }).catch((err)=>{
    //         reject(err)
    //         console.log(err)
    //     })
    // })
    
// }


//获取url参数
// const getQueryString = (url,name)=> {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
//   var r = url.match(reg);
//   if (r != null) {
//       return unescape(r[2]);
//   }
//   return null;
// }

const getClassTree = (pageList) => {
    return new Promise((resolve, reject) => {
        let newJsonObj = changeTreeDate(pageList, 'level', 'classid')
        newJsonObj = changeTreeDate(newJsonObj, 'name', 'classname')
        resolve({
            list: arrToTree(newJsonObj, 0)
        }) 
    })
  }
  
  const arrToTree = (data, pid) => {
    let result = [], temp
    for (var i = 0; i < data.length; i++) {
      if (data[i].pid === pid) {
        var obj = {'name': data[i].name, 'level': data[i].level}
        temp = arrToTree(data, data[i].level)
        if (temp.length > 0) {
          obj.children = temp
        }
        result.push(obj)
      }
    }
    return result
  }
  const changeTreeDate = (zf_jsonObj, newKey, oldKey) => {
    let str = JSON.stringify(zf_jsonObj)
    let reg = new RegExp(oldKey, 'g')
    let newStr = str.replace(reg, newKey)
    return JSON.parse(newStr)
  }
  
module.exports = { 
    getClassTree:getClassTree
}